var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    `${_vm.stickerInstance.type}Sticker`,
    _vm._b(
      {
        tag: "component",
        attrs: {
          isEditing: !_vm.previewEnabled && _vm.isSelected,
          isPreventCover: !_vm.previewEnabled && _vm.isSelected,
          isCover: !_vm.previewEnabled && _vm.isSelected,
          setCover: _vm.setCover,
          setCbClick: _vm.setCbClick,
          files: _vm.files,
          pageSelected: _vm.pageSelected,
          stickerInstance: _vm.stickerInstance,
          story: _vm.story,
          isSelected: _vm.isSelected,
        },
        on: {
          unselect: function ($event) {
            return _vm.$emit("unselect")
          },
          deleteSticker: _vm.deleteSticker,
        },
      },
      "component",
      { ..._vm.sticker, ..._vm.sticker.data },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }